import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Button, Typography } from '@mui/material';

const ValidateDialog = ({ open, onClose, onConfirm, validationResults = [] }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.25rem' }}>⚠️ RFQ Validation Warnings</DialogTitle>
      <DialogContent dividers sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Before submitting, please review the following issues found in your RFQ line items:
        </Typography>

        {validationResults.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No validation issues found.
          </Typography>
        ) : (
          validationResults.map((msg, idx) => (
            <Box key={idx} sx={{ mb: 1 }}>
              <Typography variant="body2">• {msg}</Typography>
            </Box>
          ))
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} color="secondary" variant="contained">
          Cancel Approval Submission
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Confirm and Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ValidateDialog;
